package dev.danko.roblox_craft_ai.uikit.components

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.s

val PipelineRunningPulseKeyframes = Keyframes {
    from {
        Modifier
            .scale(1f)
            .opacity(0.9f)
    }
    to {
        Modifier
            .scale(1.05f)
            .opacity(1f)
    }
}

val PipelineRunningPulseStyle = CssStyle.base {
    Modifier.opacity(0.95f)
}
